// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchCottageDetails,
//   updateCottageDetails,
//   deleteCottages,
//   uploadFile,
// } from "../actions/cottageActions";
// import { useParams } from "react-router-dom";
// import "../style/CottageDetails.css";
// import DatePicker from "react-multi-date-picker";
// import DateObject from "react-date-object";
// import persian from "react-date-object/calendars/persian";
// import persian_fa from "react-date-object/locales/persian_fa";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import CottageGoodsList from "../components/CottageGoodsList";
// import Select from "react-select";
// import { fetchCostumers } from "../actions/authActions";
// import { LazyLoading } from "../components/ui/LazyLoading";
// import HotToastMessage from "../components/ui/HotToastMessage";
// import ConfirmModal from "../components/ui/ConfirmModal";

// const CottageDetails = () => {
//   const [cottageId, setCottageId] = useState("");
//   const dispatch = useDispatch();
//   const { cottageNumber } = useParams();
//   const cottageDetails = useSelector((state) => state.cottageDetails);
//   const { loading, cottage, error } = cottageDetails;
//   const [isEditing, setIsEditing] = useState(false);
//   const [toast, setToast] = useState({ message: "", type: "info" });
//   const [showModal, setShowModal] = useState(false);

//   // State variables for each cottage field
//   const [currencyPrice, setCurrencyPrice] = useState("");
//   const [rafeeTaahod, setRafeeTaahod] = useState("");
//   const [docsRecieved, setDocsRecieved] = useState("");
//   const [rewatch, setRewatch] = useState("");
//   const [booked, setBooked] = useState("");
//   const [cottageNum, setCottageNum] = useState("");
//   const [cottageDate, setCottageDate] = useState(null);
//   const [totalValue, setTotalValue] = useState("");
//   const [addedValue, setAddedValue] = useState("");
//   const [customsValue, setCustomsValue] = useState("");
//   const [totalExpenses, setTotalExpenses] = useState("");
//   const [quantity, setQuantity] = useState("");
//   const [proforma, setProforma] = useState("");
//   const [status, setStatus] = useState("");
//   const [documents, setDocuments] = useState("");
//   const [customer, setCustomer] = useState("");
//   const [refrenceNumber, setRefrenceNumber] = useState("");
//   const [intermediary, setIntermediary] = useState("");

//   const navigate = useNavigate();

//   const costumerstate = useSelector((state) => state.costumers);
//   const { costumerList, costumersLoading, costumersError } = costumerstate || {
//     costumerList: [],
//     costumersLoading: false,
//     costumersError: null,
//   };

//   const costumerOptions = costumerList.map((cust) => ({
//     value: cust.id,
//     label: cust.full_name,
//   }));

//   const selectedCustomer = costumerList.find(
//     (c) => c.id === parseInt(customer, 10)
//   );

//   const handleDeleteCottage = () => {
//     setShowModal(true);
//   };

//   const handleConfirmDelete = () => {
//     setShowModal(false);
//     if (cottageId) {
//       dispatch(deleteCottages([cottageId]))
//         .then(() => {
//           setToast({ message: "اظهارنامه با موفقیت حذف شد.", type: "success" });
//           navigate("/cottages");
//         })
//         .catch((error) => {
//           console.error("Error deleting cottage:", error);
//           setToast({ message: "خطا در حذف اظهارنامه.", type: "error" });
//         });
//     }
//   };

//   const handleCancelDelete = () => {
//     setShowModal(false);
//   };

//   useEffect(() => {
//     if (cottageNumber) {
//       dispatch(fetchCottageDetails(cottageNumber));
//     }
//   }, [dispatch, cottageNumber]);

//   useEffect(() => {
//     dispatch(fetchCostumers());
//   }, [dispatch]);

//   useEffect(() => {
//     if (cottage) {
//       setCottageId(cottage.id || "");
//       setCurrencyPrice(cottage.currency_price || "");
//       setCottageNum(cottage.cottage_number || "");
//       setRefrenceNumber(cottage.refrence_number || "");
//       setTotalValue(cottage.total_value || "");
//       setAddedValue(cottage.added_value || "");
//       setCustomsValue(cottage.customs_value || "");
//       setQuantity(cottage.quantity || "");
//       setProforma(cottage.proforma?.prfVCodeInt || "");
//       setDocuments(cottage.documents || "");
//       setTotalExpenses(cottage.total_expenses || "");
//       setStatus(cottage.cottage_status || "");
//       setCustomer(cottage.cottage_customer?.toString() || "");
//       setRafeeTaahod(cottage.rafee_taahod === true ? "true" : "false");
//       setDocsRecieved(cottage.docs_recieved === true ? "true" : "false");
//       setRewatch(cottage.rewatch === true ? "true" : "false");
//       setBooked(cottage.booked === true ? "true" : "false");
//       setIntermediary(cottage.Intermediary || "");

//       if (cottage.cottage_date) {
//         const dateObject = new DateObject({
//           date: cottage.cottage_date,
//           format: "YYYY-MM-DD",
//           calendar: persian,
//           locale: persian_fa,
//         });
//         setCottageDate(dateObject);
//       } else {
//         setCottageDate(null);
//       }
//     }
//   }, [cottage]);

//   const handleDetailsSubmit = () => {
//     if (isEditing) {
//       if (cottageId) {
//         const updatedCottage = {
//           cottage_number: cottageNum,
//           cottage_date: cottageDate ? cottageDate.format("YYYY-MM-DD") : null,
//           total_value: totalValue,
//           customs_value: customsValue,
//           added_value: addedValue,
//           quantity: quantity,
//           cottage_status: status,
//           cottage_customer: customer,
//           total_expenses: totalExpenses,
//           Intermediary: intermediary,
//           proforma: proforma,
//           currency_price: currencyPrice,
//           rafee_taahod: rafeeTaahod,
//           docs_recieved: docsRecieved,
//           rewatch: rewatch,
//           booked: booked,
//           refrence_number: refrenceNumber,
//         };
//         dispatch(
//           updateCottageDetails(cottageId, updatedCottage, cottageNumber)
//         );
//         dispatch(uploadFile(documents, cottageId));
//       }
//     }
//     setIsEditing((prev) => !prev);
//   };

//   if (loading) {
//     return <LazyLoading />;
//   }

//   if (error) {
//     const errorMessage =
//       typeof error === "object"
//         ? (error.detail && error.detail.total_value) || JSON.stringify(error)
//         : error;

//     return (
//       <div className="error-message">
//         <p>خطا:</p>
//         <p>{errorMessage}</p>
//         <button onClick={() => dispatch(fetchCottageDetails(cottageNumber))}>
//           تلاش دوباره
//         </button>
//       </div>
//     );
//   }

//   if (!cottage) {
//     return <div className="no-details">No cottage details found.</div>;
//   }

//   return (
//     <div className="cottage-details-container shadow-md rounded-lg p-8 max-w-5xl mx-auto font-vazir mt-24 min-w-[90%]">
//       <HotToastMessage
//         message={toast.message}
//         type={toast.type}
//         duration={3000}
//         onClose={() => setToast({ message: "", type: "info" })}
//         position="top"
//       />
//       <ConfirmModal
//         isOpen={showModal}
//         onConfirm={handleConfirmDelete}
//         onCancel={handleCancelDelete}
//       />
//       <h1 className="text-3xl font-bold text-gray-900 mb-8 border-b-2 border-gray-300 pb-3">
//         جزئیات اظهارنامه
//       </h1>
//       <table className="cottage-info-table w-full border-collapse bg-white rounded-md shadow-sm mb-8">
//         <tbody>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               شماره کوتاژ:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               <span className="readonly-text">{cottageNum}</span>
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               تاریخ:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <DatePicker
//                   id="cottageDate"
//                   value={cottageDate}
//                   onChange={setCottageDate}
//                   calendar={persian}
//                   locale={persian_fa}
//                   format="YYYY/MM/DD"
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {cottageDate ? cottageDate.format("YYYY/MM/DD") : "N/A"}
//                 </span>
//               )}
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               شماره ساتا:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="text"
//                   id="refrenceNumber"
//                   placeholder="شماره ساتا را وارد کنید"
//                   value={refrenceNumber}
//                   onChange={(e) => setRefrenceNumber(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {refrenceNumber || "شماره ساتا ثبت نشده"}
//                 </span>
//               )}
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               ارزش کل:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="number"
//                   id="totalValue"
//                   value={totalValue}
//                   onChange={(e) => setTotalValue(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">{Number(totalValue).toFixed(0)}</span>
//               )}
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               ارزش گمرکی:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               <span className="readonly-text">{Number(customsValue).toFixed(0)}</span>
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               ارزش افزوده:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               <span className="readonly-text">{Number(addedValue).toFixed(0)}</span>
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               هزینه‌ها:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               <span className="readonly-text">{Number(totalExpenses).toFixed(0)}</span>
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               تعداد کالاها:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="number"
//                   id="quantity"
//                   value={quantity}
//                   onChange={(e) => setQuantity(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">{Number(quantity).toFixed(0)}</span>
//               )}
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               نام مشتری:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <Select
//                   name="cottage_customer"
//                   value={
//                     costumerOptions.find(
//                       (option) => option.value === parseInt(customer, 10)
//                     ) || null
//                   }
//                   onChange={(selectedOption) =>
//                     setCustomer(
//                       selectedOption ? selectedOption.value.toString() : ""
//                     )
//                   }
//                   options={costumerOptions}
//                   isLoading={costumersLoading}
//                   isClearable
//                   placeholder={
//                     costumersLoading
//                       ? "در حال بارگذاری..."
//                       : costumersError
//                       ? "خطا در بارگذاری"
//                       : "انتخاب مشتری"
//                   }
//                   noOptionsMessage={() =>
//                     !costumersLoading && !costumersError
//                       ? "مشتری موجود نیست"
//                       : "در حال بارگذاری..."
//                   }
//                   className="w-full"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {selectedCustomer
//                     ? selectedCustomer.full_name
//                     : "مشتری را انتخاب کنید"}
//                 </span>
//               )}
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               واسط:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="text"
//                   id="intermediary"
//                   value={intermediary}
//                   onChange={(e) => setIntermediary(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                   placeholder="نام واسط را وارد کنید"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {intermediary || "نام واسط را وارد کنید"}
//                 </span>
//               )}
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               وضعیت:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="text"
//                   id="status"
//                   placeholder="وضعیت را وارد کنید"
//                   value={status}
//                   onChange={(e) => setStatus(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {status || "وضعیت را وارد کنید"}
//                 </span>
//               )}
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               شماره پرونده ثبت سفارش:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               <span className="readonly-text">
//                 <Link to={`/order-details/${proforma}`} className="text-blue-600 hover:underline">{proforma}</Link>
//               </span>
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               نرخ ارز خرید:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="number"
//                   id="currencyPrice"
//                   placeholder="نرخ ارز را وارد کنید"
//                   value={currencyPrice}
//                   onChange={(e) => setCurrencyPrice(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">{Number(currencyPrice).toFixed(0)}</span>
//               )}
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               رفع تعهد:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="checkbox"
//                   id="rafeeTaahod"
//                   checked={rafeeTaahod === "true"}
//                   onChange={(e) =>
//                     setRafeeTaahod(e.target.checked ? "true" : "false")
//                   }
//                   className="h-5 w-5 text-blue-600 focus:ring-blue-600 border-gray-300 rounded"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {rafeeTaahod === "true" ? "بله" : "خیر"}
//                 </span>
//               )}
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               اخذ مدارک:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="checkbox"
//                   id="docsRecieved"
//                   checked={docsRecieved === "true"}
//                   onChange={(e) =>
//                     setDocsRecieved(e.target.checked ? "true" : "false")
//                   }
//                   className="h-5 w-5 text-blue-600 focus:ring-blue-600 border-gray-300 rounded"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {docsRecieved === "true" ? "بله" : "خیر"}
//                 </span>
//               )}
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               بازبینی:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="checkbox"
//                   id="rewatch"
//                   checked={rewatch === "true"}
//                   onChange={(e) => setRewatch(e.target.checked ? "true" : "false")}
//                   className="h-5 w-5 text-blue-600 focus:ring-blue-600 border-gray-300 rounded"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {rewatch === "true" ? "بله" : "خیر"}
//                 </span>
//               )}
//             </td>
//           </tr>
//           <tr className="border-b">
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               بوک شده:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-blue-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="checkbox"
//                   id="booked"
//                   checked={booked === "true"}
//                   onChange={(e) => setBooked(e.target.checked ? "true" : "false")}
//                   className="h-5 w-5 text-blue-600 focus:ring-blue-600 border-gray-300 rounded"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   {booked === "true" ? "بله" : "خیر"}
//                 </span>
//               )}
//             </td>
//             <td className="p-4 text-gray-700 font-medium w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               مدارک:
//             </td>
//             <td className="p-4 text-gray-900 w-1/4 bg-green-50 border border-gray-200 rounded-lg m-2 shadow-sm">
//               {isEditing ? (
//                 <input
//                   type="file"
//                   id="documents"
//                   onChange={(e) => setDocuments(e.target.files[0])}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 />
//               ) : (
//                 <span className="readonly-text">
//                   <Link to={documents} className="text-blue-600 hover:underline">
//                     {documents ? "دانلود" : "مدارک را اضافه کنید"}
//                   </Link>
//                 </span>
//               )}
//             </td>
//           </tr>
//         </tbody>
//       </table>

//       <div className="flex justify-end gap-4 mt-8">
//         <button
//           onClick={handleDetailsSubmit}
//           className="px-4 py-2 bg-primary text-white rounded-md hover:bg-blue-700 active:bg-blue-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
//         >
//           {isEditing ? "ذخیره" : "ویرایش"}
//         </button>
//         <button
//           onClick={handleDeleteCottage}
//           className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-700 active:bg-red-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
//         >
//           حذف اظهارنامه
//         </button>
//       </div>

//       <h2 className="text-xl font-bold text-gray-900 mb-6 mt-8 border-b-2 border-gray-300 pb-3">
//         کالاها
//       </h2>
//       {cottage.cottage_goods && cottage.cottage_goods.length > 0 ? (
//         <CottageGoodsList goods={cottage.cottage_goods} />
//       ) : (
//         <p className="text-gray-700">کالایی یافت نشد</p>
//       )}
//     </div>
//   );
// };

// export default CottageDetails;
// src/components/CottageDetails.jsx
// src/pages/CottageDetails.js
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "../components/ui/Select";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {
  fetchCottageDetails,
  updateCottageDetails,
  deleteCottages,
  uploadFile as uploadCottageFile,
} from "../actions/cottageActions";
import { fetchCostumers } from "../actions/authActions";
import CottageGoodsList from "../components/CottageGoodsList";
import { LazyLoading } from "../components/ui/LazyLoading";
import HotToastMessage from "../components/ui/HotToastMessage";
import ConfirmModal from "../components/ui/ConfirmModal";
import axiosInstance from "../utils/axiosInstance";
import {
  Building2,
  CalendarDays,
  CheckCircle2,
  ClipboardList,
  Download,
  FileText,
  Hash,
  Link2,
  Loader2,
  PanelLeftClose,
  Pencil,
  Save,
  Trash,
  Upload,
  User,
  X,
} from "lucide-react";

const cx = (...classes) => classes.filter(Boolean).join(" ");

const fmtNum = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return v ?? "-";
  return n.toLocaleString("fa-IR");
};

const Card = ({ title, icon: Icon, className = "", children, actions }) => {
  return (
    <div
      className={cx(
        "rounded-2xl border border-slate-200 bg-white shadow-sm",
        className
      )}
      dir="rtl"
    >
      {/* Header */}
      <div className="px-5 py-4 border-b border-slate-200 bg-gradient-to-b from-slate-50 to-white">
        <div className="flex items-center gap-3">
          {/* LEFT side (optional actions) */}
          <div className="flex items-center gap-2">{actions}</div>

          {/* RIGHT side (title must be at the far right) */}
          <div className="ml-auto flex items-center gap-3">
            {Icon ? (
              <div className="w-10 h-10 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
                <Icon size={20} />
              </div>
            ) : null}

            <h3 className="text-base sm:text-lg font-extrabold text-slate-800 text-right">
              {title}
            </h3>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-5">{children}</div>
    </div>
  );
};
const ReadonlyField = ({ label, icon: Icon, value }) => (
  <div className="space-y-1.5">
    <div className="block text-sm font-medium text-slate-700 text-right">
      {label}
    </div>
    <div className="relative">
      {Icon ? (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
          <Icon size={18} />
        </span>
      ) : null}
      <div
        className={cx(
          "w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-right text-slate-700",
          Icon ? "pr-10" : "pr-3"
        )}
      >
        {value || "—"}
      </div>
    </div>
  </div>
);

const InfoRow = ({ label, value, icon: Icon, valueClassName }) => (
  <div className="flex items-start justify-between gap-3 py-2 border-b border-slate-100 last:border-b-0">
    <div className="flex flex-row-reverse items-center gap-2 text-slate-600">
      {Icon ? <Icon size={16} className="text-slate-400" /> : null}
      <span className="text-sm font-semibold">{label}</span>
    </div>
    <div className={cx("text-sm text-slate-900 text-right", valueClassName)}>
      {value ?? "—"}
    </div>
  </div>
);

const Field = ({
  id,
  label,
  icon: Icon,
  type = "text",
  value,
  onChange,
  placeholder,
  inputMode,
}) => (
  <div className="space-y-1.5">
    <label
      htmlFor={id}
      className="block text-sm font-medium text-slate-700 text-right"
    >
      {label}
    </label>
    <div className="relative">
      {Icon ? (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
          <Icon size={18} />
        </span>
      ) : null}
      <input
        id={id}
        type={type}
        inputMode={inputMode}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        className={cx(
          "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-right text-slate-900",
          "placeholder:text-slate-400 shadow-sm",
          "focus:outline-none focus:ring-2 focus:ring-primary/25 focus:border-primary",
          Icon ? "pr-10" : "pr-3"
        )}
      />
    </div>
  </div>
);

const Switch = ({ checked, onChange, label, hint }) => (
  <div className="rounded-2xl border border-slate-200 bg-slate-50/60 p-4">
    <div className="flex items-center justify-between gap-3">
      <div className="text-right">
        <div className="text-sm font-semibold text-slate-800">{label}</div>
        {hint ? (
          <div className="text-xs text-slate-500 mt-1">{hint}</div>
        ) : null}
      </div>

      <label className="relative inline-flex items-center cursor-pointer select-none">
        <input
          type="checkbox"
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only peer"
        />
        <span
          className="
            relative w-11 h-6 rounded-full bg-slate-200 transition-colors
            peer-checked:bg-primary
            after:content-[''] after:absolute after:top-0.5 after:right-0.5 after:h-5 after:w-5
            after:rounded-full after:bg-white after:shadow after:transition-transform
            peer-checked:after:-translate-x-5
          "
        />
        <span className="mr-3 text-sm font-medium text-slate-700">فعال</span>
      </label>
    </div>
  </div>
);

const ModalShell = ({ open, title, icon: Icon, onClose, children, footer }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        role="button"
        tabIndex={-1}
      />
      <div className="absolute inset-0 flex items-center justify-center p-3 sm:p-6">
        <div className="w-full max-w-2xl rounded-2xl bg-white shadow-xl border border-slate-200 overflow-hidden">
          <div className="px-5 sm:px-7 py-4 border-b border-slate-200 bg-gradient-to-b from-slate-50 to-white">
            <div className="flex flex-row-reverse items-center justify-between gap-3">
              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-slate-600 hover:bg-slate-100 transition"
              >
                <X size={18} />
                بستن
              </button>

              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
                  {Icon ? <Icon size={22} /> : null}
                </div>
                <div className="text-right">
                  <div className="text-base sm:text-lg font-extrabold text-slate-800">
                    {title}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="px-5 sm:px-7 py-5 max-h-[70vh] overflow-y-auto">
            {children}
          </div>

          {footer ? (
            <div className="px-5 sm:px-7 py-4 border-t border-slate-200 bg-white">
              {footer}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const CottageDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cottageNumber } = useParams();

  const { loading, cottage, error } = useSelector(
    (state) => state.cottageDetails || {}
  );
  const {
    costumerList = [],
    costumersLoading,
    costumersError,
  } = useSelector((state) => state.costumers || {});

  const [toast, setToast] = useState({ message: "", type: "info" });
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  const [cottageId, setCottageId] = useState("");
  const [editOpen, setEditOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  // Editable fields
  const [currencyPrice, setCurrencyPrice] = useState("");
  const [rafeeTaahod, setRafeeTaahod] = useState(false);
  const [docsRecieved, setDocsRecieved] = useState(false);
  const [rewatch, setRewatch] = useState(false);
  const [exited, setExited] = useState(false);
  const [cottageNum, setCottageNum] = useState("");
  const [prfOrderNo, setPrfOrderNo] = useState("");
  const [cottageDate, setCottageDate] = useState(null);
  const [cottagePaymentDate, setCottagePaymentDate] = useState(null);
  const [totalValue, setTotalValue] = useState("");
  const [addedValue, setAddedValue] = useState("");
  const [customsValue, setCustomsValue] = useState("");
  const [totalExpenses, setTotalExpenses] = useState("");
  const [quantity, setQuantity] = useState("");
  const [proforma, setProforma] = useState("");
  const [status, setStatus] = useState("");
  const [customer, setCustomer] = useState("");
  const [refrenceNumber, setRefrenceNumber] = useState("");
  const [intermediary, setIntermediary] = useState("");
  const [documentsFile, setDocumentsFile] = useState(null);

  // Documents modal
  const [docsModalOpen, setDocsModalOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [filesLoading, setFilesLoading] = useState(false);

  // Upload modal
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [uploadDocFile, setUploadDocFile] = useState(null);
  const [uploadCategory, setUploadCategory] = useState("");
  const [uploadNotes, setUploadNotes] = useState("");
  const [uploading, setUploading] = useState(false);

  const selectPortalTarget = useMemo(
    () => (typeof document !== "undefined" ? document.body : undefined),
    []
  );
  const selectStyles = useMemo(
    () => ({
      control: (base, state) => ({
        ...base,
        minHeight: "44px",
        borderRadius: "0.75rem",
        borderColor: state.isFocused ? "#3b82f6" : "#e2e8f0",
        boxShadow: state.isFocused ? "0 0 0 2px rgba(59,130,246,0.15)" : "none",
        backgroundColor: "#ffffff",
        direction: "rtl",
        textAlign: "right",
        fontFamily: "Vazirmatn, sans-serif",
      }),
      placeholder: (b) => ({ ...b, color: "#94a3b8", textAlign: "right" }),
      singleValue: (b) => ({ ...b, color: "#0f172a", textAlign: "right" }),
      input: (b) => ({ ...b, textAlign: "right" }),

      // IMPORTANT: portal menu must be above ModalShell overlay (z-50)
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),

      menu: (b) => ({
        ...b,
        direction: "rtl",
        borderRadius: "0.75rem",
        overflow: "hidden",
        boxShadow:
          "0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -4px rgba(0,0,0,0.06)",
      }),
      option: (b, s) => ({
        ...b,
        textAlign: "right",
        backgroundColor: s.isSelected
          ? "rgba(59,130,246,1)"
          : s.isFocused
          ? "rgba(241,245,249,1)"
          : "#fff",
        color: s.isSelected ? "#fff" : "#0f172a",
      }),
    }),
    []
  );

  const costumerOptions = useMemo(
    () =>
      (costumerList || []).map((cust) => ({
        value: String(cust.id),
        label: cust.full_name,
      })),
    [costumerList]
  );

  const selectedCustomer = useMemo(() => {
    const id = Number(customer);
    if (!Number.isFinite(id)) return null;
    return (costumerList || []).find((c) => Number(c.id) === id) || null;
  }, [customer, costumerList]);

  const hydrateFromCottage = (c) => {
    setCottageId(c?.id || "");
    setCurrencyPrice(c?.currency_price ?? "");
    setCottageNum(c?.cottage_number ?? "");
    setRefrenceNumber(c?.refrence_number ?? "");
    setTotalValue(c?.total_value ?? "");
    setAddedValue(c?.added_value ?? "");
    setCustomsValue(c?.customs_value ?? "");
    setQuantity(c?.quantity ?? "");
    setProforma(c?.proforma?.prfVCodeInt ?? "");
    setTotalExpenses(c?.total_expenses ?? "");
    setStatus(c?.cottage_status ?? "");
    setCustomer(c?.cottage_customer != null ? String(c.cottage_customer) : "");
    setRafeeTaahod(!!c?.rafee_taahod);
    setDocsRecieved(!!c?.docs_recieved);
    setRewatch(!!c?.rewatch);
    setExited(!!c?.exited);
    setIntermediary(c?.Intermediary ?? "");
    setPrfOrderNo(c?.is_patteh ? "پته" : c?.proforma?.prf_order_no ?? "");
    setDocumentsFile(null);

    if (c?.cottage_date) {
      setCottageDate(
        new DateObject({
          date: c.cottage_date,
          format: "YYYY-MM-DD",
          calendar: persian,
          locale: persian_fa,
        })
      );
    } else {
      setCottageDate(null);
    }

    if (c?.cottage_payment_date) {
      setCottagePaymentDate(
        new DateObject({
          date: c.cottage_payment_date,
          format: "YYYY-MM-DD",
          calendar: persian,
          locale: persian_fa,
        })
      );
    } else {
      setCottagePaymentDate(null);
    }
  };

  useEffect(() => {
    dispatch(fetchCostumers());
  }, [dispatch]);

  useEffect(() => {
    if (cottageNumber) dispatch(fetchCottageDetails(cottageNumber));
  }, [dispatch, cottageNumber]);

  useEffect(() => {
    if (cottage) hydrateFromCottage(cottage);
  }, [cottage]);

  const fetchFiles = async (id) => {
    if (!id) return;
    setFilesLoading(true);
    try {
      const res = await axiosInstance.get(`/cottages/${id}/documents/`);
      setFiles(res.data || []);
    } catch (e) {
      setToast({ message: "خطا در بارگذاری فایل‌ها.", type: "error" });
    } finally {
      setFilesLoading(false);
    }
  };

  const openDocsModal = async () => {
    setDocsModalOpen(true);
    await fetchFiles(cottageId);
  };

  const downloadDocument = async (fileId) => {
    try {
      const file = files.find((f) => f.id === fileId);
      const res = await axiosInstance.get(
        `/cottages/${cottageId}/documents/${fileId}/download`,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = file?.original_name || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setToast({ message: "خطا در دانلود فایل.", type: "error" });
    }
  };

  const deleteDocument = async (fileId) => {
    try {
      await axiosInstance.delete(`/cottages/${cottageId}/documents/${fileId}/`);
      setToast({ message: "سند با موفقیت حذف شد.", type: "success" });
      await fetchFiles(cottageId);
    } catch (e) {
      setToast({ message: "خطا در حذف سند.", type: "error" });
    }
  };

  const submitUpload = async () => {
    if (!uploadDocFile || !uploadCategory) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", uploadDocFile);
      fd.append("category", uploadCategory);
      fd.append("notes", uploadNotes);

      await axiosInstance.post(`/cottages/${cottageId}/upload-document/`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setToast({ message: "فایل با موفقیت آپلود شد.", type: "success" });
      setUploadModalOpen(false);
      setUploadDocFile(null);
      setUploadCategory("");
      setUploadNotes("");
      await fetchFiles(cottageId);
    } catch (e) {
      setToast({ message: "خطا در آپلود فایل.", type: "error" });
    } finally {
      setUploading(false);
    }
  };

  const submitDeleteCottage = async () => {
    setConfirmDeleteOpen(false);
    if (!cottageId) return;

    try {
      await dispatch(deleteCottages([cottageId]));
      setToast({ message: "اظهارنامه با موفقیت حذف شد.", type: "success" });
      navigate("/cottages");
    } catch (e) {
      setToast({ message: "خطا در حذف اظهارنامه.", type: "error" });
    }
  };

  const submitEdit = async () => {
    if (!cottageId) return;
    setSaving(true);

    const payload = {
      cottage_date: cottageDate ? cottageDate.format("YYYY-MM-DD") : null,
      cottage_payment_date: cottagePaymentDate
        ? cottagePaymentDate.format("YYYY-MM-DD")
        : null,
      total_value: totalValue,
      customs_value: customsValue,
      added_value: addedValue,
      quantity,
      cottage_status: status,
      cottage_customer: customer,
      total_expenses: totalExpenses,
      Intermediary: intermediary,
      proforma,
      currency_price: currencyPrice,
      rafee_taahod: rafeeTaahod,
      docs_recieved: docsRecieved,
      rewatch,
      exited,
    };

    try {
      await dispatch(updateCottageDetails(cottageId, payload, cottageNumber));

      // Optional legacy single-file upload hook (kept to match your old behavior)
      if (documentsFile instanceof File) {
        await dispatch(uploadCottageFile(documentsFile, cottageId));
      }

      setToast({ message: "تغییرات با موفقیت ذخیره شد.", type: "success" });
      setEditOpen(false);
      dispatch(fetchCottageDetails(cottageNumber));
    } catch (e) {
      setToast({ message: "خطا در ذخیره تغییرات.", type: "error" });
    } finally {
      setSaving(false);
    }
  };

  // ---- Early returns (AFTER hooks) ----
  if (loading) return <LazyLoading />;

  if (error) {
    const errorMessage =
      typeof error === "object"
        ? (error?.detail && error.detail.total_value) || JSON.stringify(error)
        : String(error);

    return (
      <div
        className="mt-24 max-w-3xl mx-auto px-3 sm:px-6 font-vazirmatn"
        dir="rtl"
      >
        <div className="rounded-2xl border border-rose-200 bg-rose-50 px-5 py-4 text-rose-800">
          <div className="font-extrabold mb-1">خطا</div>
          <div className="text-sm">{errorMessage}</div>
          <button
            onClick={() => dispatch(fetchCottageDetails(cottageNumber))}
            className="mt-4 inline-flex items-center justify-center rounded-xl bg-rose-600 px-4 py-2.5 text-sm font-bold text-white hover:opacity-95"
          >
            تلاش دوباره
          </button>
        </div>
      </div>
    );
  }

  if (!cottage) {
    return (
      <div
        className="mt-24 max-w-3xl mx-auto px-3 sm:px-6 font-vazirmatn"
        dir="rtl"
      >
        <div className="rounded-2xl border border-slate-200 bg-white px-5 py-6 text-slate-700">
          اطلاعات اظهارنامه یافت نشد.
        </div>
      </div>
    );
  }

  return (
    <div className="mt-20 sm:mt-24 px-3 sm:px-6 font-vazirmatn" dir="rtl">
      <HotToastMessage
        message={toast.message}
        type={toast.type}
        duration={3000}
        onClose={() => setToast({ message: "", type: "info" })}
        position="top"
      />

      <ConfirmModal
        isOpen={confirmDeleteOpen}
        onConfirm={submitDeleteCottage}
        onCancel={() => setConfirmDeleteOpen(false)}
      />

      {/* Page header */}
      <div className="max-w-6xl mx-auto">
        <div className="rounded-2xl border border-slate-200 bg-white/95 backdrop-blur shadow-sm overflow-hidden">
          <div className="px-5 sm:px-7 py-5 border-b border-slate-200 bg-gradient-to-b from-slate-50 to-white">
            <div className="flex flex-row-reverse items-center justify-between gap-3">
              <button
                type="button"
                onClick={() => navigate("/cottages")}
                className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-slate-600 hover:bg-slate-100 transition"
              >
                <PanelLeftClose size={18} />
                بازگشت
              </button>

              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
                  <ClipboardList size={22} />
                </div>
                <div className="text-right">
                  <h1 className="text-lg sm:text-xl font-extrabold text-slate-800">
                    جزئیات اظهارنامه
                  </h1>
                  <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
                    شماره کوتاژ: <span className="font-bold">{cottageNum}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="px-5 sm:px-7 py-4">
            <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-end">
              <button
                type="button"
                onClick={openDocsModal}
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50 transition"
              >
                <FileText size={18} />
                مشاهده مدارک
              </button>
              <button
                type="button"
                onClick={() => {
                  hydrateFromCottage(cottage);

                  // Ensure list exists before showing select options
                  if (
                    (!costumerList || costumerList.length === 0) &&
                    !costumersLoading
                  ) {
                    dispatch(fetchCostumers());
                  }

                  setEditOpen(true);
                }}
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-bold text-white hover:opacity-95 transition"
              >
                <Pencil size={18} />
                ویرایش
              </button>

              <button
                type="button"
                onClick={() => setConfirmDeleteOpen(true)}
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-rose-600 px-4 py-2.5 text-sm font-bold text-white hover:opacity-95 transition"
              >
                <Trash size={18} />
                حذف اظهارنامه
              </button>
            </div>

            {costumersError ? (
              <div className="mt-3 text-sm text-rose-700 text-right">
                خطا در دریافت لیست مشتریان
              </div>
            ) : null}
          </div>
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
          <Card title="اطلاعات اصلی" icon={Hash} className="lg:col-span-2 ">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="rounded-2xl border border-slate-200 bg-slate-50/60 p-4">
                <InfoRow
                  label="شماره کوتاژ"
                  value={cottageNum || "—"}
                  icon={Hash}
                />
                <InfoRow
                  label="تاریخ کوتاژ"
                  value={cottageDate ? cottageDate.format("YYYY/MM/DD") : "—"}
                  icon={CalendarDays}
                />
                <InfoRow
                  label="تاریخ رسید پرداخت"
                  value={
                    cottagePaymentDate
                      ? cottagePaymentDate.format("YYYY/MM/DD")
                      : "—"
                  }
                  icon={CalendarDays}
                />
                <InfoRow
                  label="شماره ساتا"
                  value={refrenceNumber || "—"}
                  icon={Link2}
                />
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-4">
                <InfoRow
                  label="نام مشتری"
                  value={
                    selectedCustomer ? (
                      <Link
                        className="text-blue-700 hover:underline"
                        to={`/customers/details/${selectedCustomer.id}`}
                      >
                        {selectedCustomer.full_name}
                      </Link>
                    ) : (
                      "—"
                    )
                  }
                  icon={User}
                />
                <InfoRow
                  label="واسط"
                  value={intermediary || "—"}
                  icon={Building2}
                />
                <InfoRow
                  label="وضعیت"
                  value={status || "—"}
                  icon={CheckCircle2}
                />
                <InfoRow
                  label="پرونده ثبت سفارش"
                  value={
                    proforma ? (
                      <Link
                        to={`/order-details/${proforma}`}
                        className="text-primary hover:underline"
                      >
                        {proforma}
                      </Link>
                    ) : (
                      prfOrderNo === "پته" ? "پته" : "—"
                    )
                  }
                  icon={ClipboardList}
                  valueClassName="text-left"
                />
              </div>
            </div>
          </Card>

          <Card title="ارقام و وضعیت‌ها" icon={CheckCircle2}>
            <div className="rounded-2xl border border-slate-200 bg-white p-4">
              <InfoRow label="ارزش کل" value={fmtNum(totalValue)} />
              <InfoRow label="ارزش گمرکی" value={fmtNum(customsValue)} />
              <InfoRow label="ارزش افزوده" value={fmtNum(addedValue)} />
              <InfoRow label="هزینه‌ها" value={fmtNum(totalExpenses)} />
              <InfoRow label="تعداد کالاها" value={fmtNum(quantity)} />
              <InfoRow label="نرخ ارز خرید" value={fmtNum(currencyPrice)} />
              <InfoRow label="رفع تعهد" value={rafeeTaahod ? "بله" : "خیر"} />
              <InfoRow label="اخذ مدارک" value={docsRecieved ? "بله" : "خیر"} />
              <InfoRow label="بازبینی" value={rewatch ? "بله" : "خیر"} />
              <InfoRow label="خروج شده" value={exited ? "بله" : "خیر"} />
            </div>
          </Card>
        </div>

        {/* Goods */}
        <div className="mt-4">
          <Card title="کالاها" icon={ClipboardList}>
            {cottage?.cottage_goods && cottage.cottage_goods.length > 0 ? (
              <CottageGoodsList goods={cottage.cottage_goods} />
            ) : (
              <div className="text-slate-600 text-sm">کالایی یافت نشد</div>
            )}
          </Card>
        </div>
      </div>

      {/* Documents modal */}
      <ModalShell
        open={docsModalOpen}
        title="مدارک اظهارنامه"
        icon={FileText}
        onClose={() => setDocsModalOpen(false)}
        footer={
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
            <button
              type="button"
              onClick={() => {
                setUploadModalOpen(true);
                setUploadDocFile(null);
                setUploadCategory("");
                setUploadNotes("");
              }}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-bold text-white hover:opacity-95"
            >
              <Upload size={18} />
              آپلود فایل
            </button>

            <button
              type="button"
              onClick={() => setDocsModalOpen(false)}
              className="inline-flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50"
            >
              بستن
            </button>
          </div>
        }
      >
        {filesLoading ? (
          <div className="flex items-center justify-center h-32">
            <LazyLoading />
          </div>
        ) : (
          <div className="space-y-2">
            {files?.length ? (
              files.map((f) => (
                <div
                  key={f.id}
                  className="flex flex-row-reverse items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3"
                >
                  <div className="text-right">
                    <div className="text-sm font-bold text-slate-800">
                      {f.original_name}
                    </div>
                    <div className="text-xs text-slate-500 mt-0.5">
                      {f.category || "—"}
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => downloadDocument(f.id)}
                      className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white p-2 hover:bg-slate-50"
                      title="دانلود"
                    >
                      <Download size={18} className="text-emerald-600" />
                    </button>

                    <button
                      type="button"
                      onClick={() => deleteDocument(f.id)}
                      className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white p-2 hover:bg-slate-50"
                      title="حذف"
                    >
                      <Trash size={18} className="text-rose-600" />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-slate-600 text-sm text-right">
                فایلی یافت نشد
              </div>
            )}
          </div>
        )}
      </ModalShell>

      {/* Upload modal */}
      <ModalShell
        open={uploadModalOpen}
        title="آپلود فایل"
        icon={Upload}
        onClose={() => setUploadModalOpen(false)}
        footer={
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
            <button
              type="button"
              onClick={() => setUploadModalOpen(false)}
              className="inline-flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50"
              disabled={uploading}
            >
              انصراف
            </button>

            <button
              type="button"
              onClick={submitUpload}
              disabled={!uploadDocFile || !uploadCategory || uploading}
              className={cx(
                "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold text-white",
                "bg-primary hover:opacity-95 transition",
                "disabled:opacity-50 disabled:cursor-not-allowed"
              )}
            >
              {uploading ? (
                <>
                  <Loader2 className="animate-spin" size={18} />
                  در حال آپلود...
                </>
              ) : (
                "آپلود"
              )}
            </button>
          </div>
        }
      >
        <div className="space-y-4">
          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-slate-700 text-right">
              فایل
            </label>
            <input
              type="file"
              onChange={(e) => setUploadDocFile(e.target.files?.[0] || null)}
              className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-right shadow-sm"
            />
          </div>

          <Field
            id="uploadCategory"
            label="دسته‌بندی"
            icon={Hash}
            value={uploadCategory}
            onChange={(e) => setUploadCategory(e.target.value)}
            placeholder="مثال: INVOICE"
          />

          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-slate-700 text-right">
              یادداشت‌ها
            </label>
            <textarea
              value={uploadNotes}
              onChange={(e) => setUploadNotes(e.target.value)}
              placeholder="یادداشت‌ها"
              className={cx(
                "w-full min-h-[90px] rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-right text-slate-900",
                "placeholder:text-slate-400 shadow-sm",
                "focus:outline-none focus:ring-2 focus:ring-primary/25 focus:border-primary"
              )}
            />
          </div>
        </div>
      </ModalShell>

      {/* Edit overlay */}
      <ModalShell
        open={editOpen}
        title="ویرایش اظهارنامه"
        icon={Pencil}
        onClose={() => setEditOpen(false)}
        footer={
          <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
            <button
              type="button"
              onClick={() => {
                hydrateFromCottage(cottage);
                setEditOpen(false);
              }}
              className="inline-flex items-center justify-center rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50"
              disabled={saving}
            >
              انصراف
            </button>

            <button
              type="button"
              onClick={submitEdit}
              disabled={saving}
              className={cx(
                "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold text-white",
                "bg-primary hover:opacity-95 transition",
                "disabled:opacity-50 disabled:cursor-not-allowed"
              )}
            >
              {saving ? (
                <>
                  <Loader2 className="animate-spin" size={18} />
                  در حال ذخیره...
                </>
              ) : (
                <>
                  <Save size={18} />
                  ذخیره
                </>
              )}
            </button>
          </div>
        }
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReadonlyField label="شماره کوتاژ" icon={Hash} value={cottageNum} />
          <ReadonlyField
            label="شماره ساتا"
            icon={Link2}
            value={refrenceNumber}
          />

          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-slate-700 text-right">
              تاریخ کوتاژ
            </label>
            <div className="relative">
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
                <CalendarDays size={18} />
              </span>
              <DatePicker
                value={cottageDate}
                onChange={setCottageDate}
                calendar={persian}
                locale={persian_fa}
                format="YYYY/MM/DD"
                inputClass={cx(
                  "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 pr-10 text-right text-slate-900",
                  "placeholder:text-slate-400 shadow-sm",
                  "focus:outline-none focus:ring-2 focus:ring-primary/25 focus:border-primary"
                )}
                containerClassName="w-full"
                calendarPosition="bottom-right"
              />
            </div>
          </div>

          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-slate-700 text-right">
              تاریخ رسید پرداخت
            </label>
            <div className="relative">
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
                <CalendarDays size={18} />
              </span>
              <DatePicker
                value={cottagePaymentDate}
                onChange={setCottagePaymentDate}
                calendar={persian}
                locale={persian_fa}
                format="YYYY/MM/DD"
                inputClass={cx(
                  "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 pr-10 text-right text-slate-900",
                  "placeholder:text-slate-400 shadow-sm",
                  "focus:outline-none focus:ring-2 focus:ring-primary/25 focus:border-primary"
                )}
                containerClassName="w-full"
                calendarPosition="bottom-right"
              />
            </div>
          </div>

          <Field
            id="totalValue"
            label="ارزش کل"
            icon={ClipboardList}
            type="number"
            inputMode="numeric"
            value={totalValue}
            onChange={(e) => setTotalValue(e.target.value)}
          />

          <Field
            id="customsValue"
            label="ارزش گمرکی"
            icon={ClipboardList}
            type="number"
            inputMode="numeric"
            value={customsValue}
            onChange={(e) => setCustomsValue(e.target.value)}
          />

          <Field
            id="addedValue"
            label="ارزش افزوده"
            icon={ClipboardList}
            type="number"
            inputMode="numeric"
            value={addedValue}
            onChange={(e) => setAddedValue(e.target.value)}
          />

          <Field
            id="totalExpenses"
            label="هزینه‌ها"
            icon={ClipboardList}
            type="number"
            inputMode="numeric"
            value={totalExpenses}
            onChange={(e) => setTotalExpenses(e.target.value)}
          />

          <Field
            id="quantity"
            label="تعداد کالاها"
            icon={ClipboardList}
            type="number"
            inputMode="numeric"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />

          <Field
            id="currencyPrice"
            label="نرخ ارز خرید"
            icon={ClipboardList}
            type="number"
            inputMode="numeric"
            value={currencyPrice}
            onChange={(e) => setCurrencyPrice(e.target.value)}
          />

          <Field
            id="status"
            label="وضعیت"
            icon={CheckCircle2}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          />

          <Field
            id="intermediary"
            label="واسط"
            icon={Building2}
            value={intermediary}
            onChange={(e) => setIntermediary(e.target.value)}
          />

          <ReadonlyField
            label="پرونده ثبت سفارش"
            icon={Link2}
            value={prfOrderNo === "پته" ? "پته" : proforma}
          />
          <ReadonlyField
            label="شماره ثبت سفارش"
            icon={Hash}
            value={prfOrderNo}
          />

          <div className="md:col-span-2 space-y-1.5">
            <label className="block text-sm font-medium text-slate-700 text-right">
              نام مشتری
            </label>
            <Select
              options={costumerOptions}
              isLoading={costumersLoading}
              isClearable
              placeholder={
                costumersLoading ? "در حال بارگذاری..." : "انتخاب مشتری"
              }
              noOptionsMessage={() => "مشتری موجود نیست"}
              styles={selectStyles}
              menuPortalTarget={selectPortalTarget}
              menuPosition={selectPortalTarget ? "fixed" : "absolute"}
              value={
                costumerOptions.find((o) => o.value === String(customer)) ||
                null
              }
              onChange={(opt) => setCustomer(opt ? opt.value : "")}
            />
          </div>

          <div className="md:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Switch
                checked={rafeeTaahod}
                onChange={setRafeeTaahod}
                label="رفع تعهد"
              />
              <Switch
                checked={docsRecieved}
                onChange={setDocsRecieved}
                label="اخذ مدارک"
              />
              <Switch checked={rewatch} onChange={setRewatch} label="بازبینی" />
              <Switch checked={exited} onChange={setExited} label="خروج شده" />
            </div>
          </div>

          {/* Optional legacy single-file upload */}
          {/* <div className="md:col-span-2 space-y-1.5">
            <label className="block text-sm font-medium text-slate-700 text-right">
              فایل (اختیاری)
            </label>
            <div className="rounded-2xl border border-slate-200 bg-white p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="text-right">
                  <div className="text-sm font-semibold text-slate-800">
                    پیوست
                  </div>
                  <div className="text-xs text-slate-500 mt-1">
                    اگر این فیلد در بک‌اند شما فعال است، می‌توانید یک فایل واحد
                    هم ارسال کنید.
                  </div>
                </div>
                <Upload size={18} className="text-slate-400 mt-0.5" />
              </div>

              <input
                type="file"
                onChange={(e) => setDocumentsFile(e.target.files?.[0] || null)}
                className="mt-3 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-right shadow-sm"
              />
            </div>
          </div> */}
        </div>
      </ModalShell>
    </div>
  );
};

export default CottageDetails;
